export const holidaysSets = {
    1: {
      'Nowy Rok': '0101',
      'Trzech Króli': '0106',
      'Święto Pracy': '0501',
      'Święto Konstytucji 3 Maja': '0503',
      'Święto Narodowe 15 Sierpnia': '0815',
      'Święto Wszystkich Świętych': '1101',
      'Święto Niepodległości': '1111',
      'Boże Narodzenie (pierwszy dzień)': '1225',
      'Boże Narodzenie (drugi dzień)': '1226',
      'Wielkanoc': 'W',
      'Poniedziałek Wielkanocny': 'W+1',
      'Zielone Świątki': 'W+49',
      'Boże Ciało': 'W+60'
    },
    2: {
      'Nowy Rok': '0101',
      'Boże Narodzenie (pierwszy dzień)': '1225',
      'Boże Narodzenie (drugi dzień)': '1226',
      'Wielkanoc': 'W',
      'Poniedziałek Wielkanocny': 'W+1'    
    },
    3: {
      'Nowy Rok': '0101',
      'Boże Narodzenie (pierwszy dzień)': '1225',
      'Wielkanoc': 'W',
    },
    4: {
      'Wigilia Bożego Narodzenia': '1224',
      'sylwester': '1231'
    },
    5: {
      'Wielka Sobota': 'W+-1',
      'Wielki Piątek': 'W+-2',
      'Wielki Czwartek': 'W+-3'
    },
    6: {
      'Wielka Sobota': 'W+-1'
    },
    7: {
      '2 maja': '0502',
      'piątek po Bożym Ciele': 'W+61'
    }
  };


export default function gtfsFormatDate(dateString) {
    // Parsowanie daty
    const year = parseInt(dateString.substring(0, 4), 10);
    const month = parseInt(dateString.substring(4, 6), 10) - 1; // Miesiące w JS są zerobazowe
    const day = parseInt(dateString.substring(6, 8), 10);

    // Tworzenie obiektu Date
    const date = new Date(year, month, day);

    // Formatowanie daty do DD.MM.YYYY
    return date.toLocaleDateString("pl-PL");
}

export function gtfsParseYYYYMMDD(dateString) {
    if (!dateString) return null;

    const year = parseInt(dateString.substring(0, 4), 10);
    const month = parseInt(dateString.substring(4, 6), 10) - 1; // Miesiące są zerobazowe w JS
    const day = parseInt(dateString.substring(6, 8), 10);

    // Tworzenie obiektu Date
    return new Date(year, month, day);
}

export function gtfsFormatDateToYYYYMMDD(date) {
    if (!date) return false;
    const year = date.getFullYear(); // Pobiera rok
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Miesiące są zerobazowe, więc dodaj 1
    const day = String(date.getDate()).padStart(2, '0'); // Dodaj wiodące zero, jeśli potrzeba

    return `${year}${month}${day}`;
}

export function parseDMYDate(dateStr) {       
        const [day, month, year] = dateStr.split('.').map(Number);
        return new Date(year, month - 1, day); // Miesiące w JS są indeksowane od 0
    };


export function listHolidays(startDate,endDate,holidaySet) {
    let begining;
    let ending;

    begining = startDate;
    ending = endDate;
    dateList = [];

    for(let i = begining.getFullYear(); i <= ending.getFullYear(); i++) {
        //dla każdego roku z przedziału...
        //oblicz święta stałe
        for(const [key, value] of Object.entries(holidaySet)) {
            let holiday;
            //data święta
            if(value[0] === 'W') {
                //święto ruchome
                let odlegloscOdWielkanocy = 0;
                if(value.length > 1) {
                    let substr = value.split('+');
                    odlegloscOdWielkanocy = parseInt(substr[1]);
                }
                moveableFeastDate = calculateEaster(i,true);
                moveableFeastDate.setDate(moveableFeastDate.getDate() + odlegloscOdWielkanocy);
                if( moveableFeastDate >= begining && moveableFeastDate <= ending ) {
                    dateList.push(String(moveableFeastDate.getFullYear()) + String(moveableFeastDate.getMonth() + 1).padStart(2,0) + String(moveableFeastDate.getDate()).padStart(2,0));
                }
            } else {
                //święto nieruchome
                holiday = gtfsParseYYYYMMDD(i.toString() + value.toString());
                if( holiday >= begining && holiday <= ending ) {
                    dateList.push(i.toString() + value.toString());
                }
            }           
        }
    }
    dateList.sort();
    return dateList;
}

function calculateEaster(rok,zwrocObiektDaty = false) {
    var a = rok % 19;
    var b = Math.floor(rok / 100);
    var c = rok % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var p = (h + l - 7 * m + 114) % 31;
    var dzien = p + 1;
    var miesiac = Math.floor((h + l - 7 * m + 114) / 31);
  
    if (zwrocObiektDaty) {
      return new Date(rok, miesiac - 1, dzien);
    } else {
      return String(rok) + String(miesiac).padStart(2,0) + String(dzien).padStart(2,0);
    }
}

export function parseTimeStringToDate(timeString) {
  if (typeof timeString !== 'string') return false;
  const [hours, minutes, seconds = 0] = timeString.split(":").map(Number); 
  const date = new Date();
  date.setHours(hours % 24, minutes, seconds, 0);
  return date;
}

export function formatDateToTimeString(date,addDay = 0) {
  if(date) {  
    const hours = (addDay) ? Number(date.getHours() + (addDay * 24)).toString().padStart(2,'0') : date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds();

    if (seconds !== 0) {
        return `${hours}:${minutes}:${seconds.toString().padStart(2, '0')}`;
    } else {
        return `${hours}:${minutes}`;
    }
  } 
}

export function formatGtfsTimeString(gtfsTimeString) {
  if(typeof gtfsTimeString !== 'string') return null;
  let addDay = 0;
  let dayIndicator = (<></>);

  let gtfsTimeArray = gtfsTimeString.split(':');
  if (gtfsTimeArray.length > 3) return null;

  if (parseInt(gtfsTimeArray[0]) > 23) {
      addDay = Math.floor(parseInt(gtfsTimeArray[0]) / 24);
      gtfsTimeArray[0] = parseInt(gtfsTimeArray[0]) - (addDay * 24);
      gtfsTimeArray[0] = (gtfsTimeArray[0] <= 9) ? '0' + gtfsTimeArray[0].toString() : gtfsTimeArray[0].toString();
      dayIndicator = <sup className="text-green-500 text-xs" title={(addDay === 1) ? 'następnego dnia' : '+ '+ addDay + ' dni'}>+{addDay}&nbsp;d.</sup>
  }

  return (gtfsTimeArray[2] === '00') ? 
      ( <> {gtfsTimeArray[0] + ':' + gtfsTimeArray[1]}{dayIndicator} </>)
      :
      ( <> {gtfsTimeArray[0] + ':' + gtfsTimeArray[1]}<sub className="text-xs text-400">:{gtfsTimeArray[2]}</sub>{dayIndicator}</> )
}

export function gtfsTimeStringToSeconds(gtfsTimeString) {
    if(!typeof gtfsTimeString === 'string') return;
    // Rozdzielenie czasu na godziny, minuty i ewentualnie sekundy
    const [godziny, minuty, sekundy = 0] = gtfsTimeString.split(':').map(Number);
    
    // Obliczenie całkowitej liczby sekund
    return godziny * 3600 + minuty * 60 + sekundy;
}

export function secondsToGtfsTimeString(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  
  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(secs).padStart(2, '0');

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
}

export function isValidGtfsTimeFormat(timeString) {
  const regex = /^(\d{1,}):([0-5]?\d)(:([0-5]?\d))?$/;
  const match = timeString.match(regex);

  if (!match) {
      return false;
  }

  const hours = parseInt(match[1], 10);
  const minutes = parseInt(match[2], 10);
  const seconds = match[4] !== undefined ? parseInt(match[4], 10) : null;

  // Walidacja minut i sekund
  if (minutes >= 60 || (seconds !== null && seconds >= 60)) {
      return false;
  }

  return true;
}

